import * as React from 'react'
import type { SVGProps } from 'react'
function SvgWohnraumEinheitenStadtbau2219826271102(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 255.7 214.4"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M164.9,81.3L120.3,44c-1.1-0.9-2.8-0.9-3.9,0L71.8,81.3c-1,0.8-1.3,2.2-0.9,3.4c0.4,1.2,1.6,2,2.9,2h15.9v115.6 c0,6.7,5.4,12.1,12.1,12.1h33.1c6.7,0,12.1-5.4,12.1-12.1V86.7H163c1.3,0,2.4-0.8,2.9-2C166.3,83.5,165.9,82.2,164.9,81.3z  M92.7,80.6H82.1l36.2-30.3l36.2,30.3H144c-1.7,0-3,1.4-3,3.1v118.6c0,3.3-2.7,6-6,6h-33.1c-3.3,0-6-2.7-6-6V83.7 C95.8,82,94.4,80.6,92.7,80.6z" />
        <path d="M233.7,137.9c-1.7,0-3,1.4-3,3.1v61.3c0,3.3-2.7,6-6,6h-33.2c-3.3,0-6-2.7-6-6V101.4c0-1.7-1.4-3-3.1-3c-1.7,0-3,1.4-3,3 v100.9c0,6.7,5.4,12.1,12.1,12.1h33.2c6.7,0,12.1-5.4,12.1-12.1v-61.3C236.7,139.3,235.3,137.9,233.7,137.9z" />
        <path d="M233.7,98.4c-1.7,0-3,1.4-3,3v21.5c0,1.7,1.4,3,3,3s3-1.4,3-3v-21.5C236.7,99.7,235.3,98.4,233.7,98.4z" />
        <path d="M254.6,38.1L210,0.7c-1.1-0.9-2.8-0.9-3.9,0l-11.3,9.4V7.2c0-1.7-1.4-3-3-3h-15.4c-1.7,0-3.1,1.4-3.1,3v21l-11.8,9.9 c-1,0.8-1.3,2.2-0.9,3.4c0.4,1.2,1.6,2,2.9,2h15.9v39.2c0,1.7,1.4,3.1,3,3.1c1.7,0,3.1-1.4,3.1-3.1V40.4c0-1.7-1.4-3.1-3.1-3.1 h-10.5l6.5-5.4c0.7-0.6,1.1-1.4,1.1-2.3V10.2h9.3v6.4c0,1.2,0.7,2.3,1.8,2.8c1.1,0.5,2.4,0.3,3.2-0.4L208,7l36.2,30.3h-10.5 c-1.7,0-3,1.4-3,3.1v42.3c0,1.7,1.4,3.1,3,3.1s3-1.4,3-3.1V43.4h15.9c1.3,0,2.4-0.8,2.9-2C255.9,40.2,255.5,38.9,254.6,38.1z" />
        <path d="M44,86.6H13.4C6,86.6,0,92.6,0,100v102.3c0,6.7,5.4,12.1,12.1,12.1h33.2c6.7,0,12.1-5.4,12.1-12.1V100 C57.4,92.6,51.4,86.6,44,86.6z M51.3,100v102.3c0,3.3-2.7,6-6,6H12.1c-3.3,0-6-2.7-6-6V100c0-4,3.3-7.3,7.3-7.3H44 C48,92.7,51.3,96,51.3,100z" />
      </g>
    </svg>
  )
}
export default SvgWohnraumEinheitenStadtbau2219826271102
